<div class="row">
  <div class="col-lg-12 grid-margin">
    <div class="card">
      <div class="card-body upper-header">
        <div class="row">
          <div class="form-group col-1.5 ml-2">
            <label>From Date</label>
            <input class="form-control border-primary" [max]="to_date" [owlDateTime]="dt" placeholder="Date" name="from_date"
              [(ngModel)]="from_date" readonly>
            <span [owlDateTimeTrigger]="dt" class="date-ico"><i class="fa fa-calendar"></i></span>
            <owl-date-time #dt [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
          </div>
          <div class="form-group col-1.5 ml-2 mr-2">
            <label>To Date</label>
            <input class="form-control border-primary" [min]="from_date" [max]="maxDate" [owlDateTime]="dt1" placeholder="Date" name="to_date"
              [(ngModel)]="to_date" readonly>
            <span [owlDateTimeTrigger]="dt1" class="date-ico"><i class="fa fa-calendar"></i></span>
            <owl-date-time #dt1 [pickerType]="'calendar'" [pickerMode]="'dialog'"></owl-date-time>
          </div>
          <div class="form-group col-2">
            <label>Payment Status</label>
            <select class="form-control border-primary" name="payment_status" [(ngModel)]="payment_status">
              <option [value]="''">All</option>
              <option value="pending">Pending</option>
              <option value="paid">Paid</option>
            </select>
          </div>
          <div class="form-group col-2">
            <button type="button" style="margin-top: 30px;" class="btn btn-primary btn-fw" (click)="getReport()">Load</button>
          </div>
        </div>
        <h4 class="card-title">
          <div class="d-flex bd-highlight">
            <div class="p-2 flex-grow-1 bd-highlight">Annakshetra Summary Report</div>
            <div class="p-2 bd-highlight">
              <button type="btn" class="btn btn-primary btn-fw" (click)="exportData()">Export</button>
            </div>
          </div>
        </h4>
        

        <div class="table-responsive mt-4" *ngIf="summaryReport && summaryReport.date_wise && summaryReport.date_wise.length">
          <!-- <h5 class="mb-3">Date Wise Summary</h5> -->
          <table class="table">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Sweet Prasad Count</th>
                <th>Sweet Prasad Amount</th>
                <th>Half-Day Meal Count</th>
                <th>Half-Day Meal Amount</th>
                <th>Full-Day Meal Count</th>
                <th>Full-Day Meal Amount</th>
                <th>Total Count</th>
                <th>Total Amount</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let day of summaryReport.date_wise; let i = index">
                 <td>
                  {{i+1}}
                </td>
                <td>{{day?.date || 'N/A'}}</td>
                <td>{{day?.meal_types['sweet-prasad'].count || 0}}</td>
                <td>₹{{day?.meal_types['sweet-prasad'].amount || 0}}</td>
                <td>{{day?.meal_types['one-time-meal'].count || 0}}</td>
                <td>₹{{day?.meal_types['one-time-meal'].amount || 0}}</td>
                <td>{{day?.meal_types['full-day-meal'].count || 0}}</td>
                <td>₹{{day?.meal_types['full-day-meal'].amount || 0}}</td>
                <td>{{day?.total_count || 0}}</td>
                <td>₹{{day?.total_amount || 0}}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="p-12" *ngIf="summaryReport && (!summaryReport.date_wise || !summaryReport.date_wise.length)">
          <span class="ng-star-inserted no_data">No Data found.</span>
        </div>
      </div>
    </div>
  </div>
</div>
